import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { finalize } from 'rxjs';
import { AdminAuthService } from '../../../core/auth/admin-auth.service';

@Component({
  selector: 'app-admin-register',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterLink,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
  ],
  templateUrl: './admin-register.html',
  styleUrl: './admin-register.scss',
})
export class AdminRegisterComponent {
  isSubmitting = false;
  registerError = '';
  showPassword = false;
  showConfirmPassword = false;
  readonly form;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AdminAuthService,
  ) {
    this.form = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],
      confirmPassword: ['', [Validators.required]],
    });

    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/property/rent/manage']);
    }
  }

  onSubmit(): void {
    this.registerError = '';

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;

    const username = this.form.get('username')?.value ?? '';
    const password = this.form.get('password')?.value ?? '';
    const confirmPassword = this.form.get('confirmPassword')?.value ?? '';

    this.authService
      .register(username, password, confirmPassword)
      .pipe(finalize(() => (this.isSubmitting = false)))
      .subscribe({
        next: () => {
          this.router.navigate(['/property/rent/manage']);
        },
        error: (error) => {
          this.registerError = this.authService.getErrorMessage(
            error,
            'Unable to register. Please try again.',
          );
        },
      });
  }
}
